<template>
  <div
    class="vgsi__panel"
  >
    <div class="vgsi__panel-top">
      <div class="vgsi__panel-indicator">
        <div class="vgsi__panel-current">{{ current.number + 1 }}</div>
        <div class="vgsi__panel-direction">
          <span class="arrow-up" />
          <span class="arrow-down" />
        </div>
      </div>
      <div class="vgsi__panel-indicator-label">
        <h4>{{ current.label }}</h4>
      </div>
    </div>
    <div class="vgsi__panel-body">
      <div class="vgsi__panel-buttons">
        <div class="vgsi__panel-buttons__top">
          <Button
            v-for="(item, index) in solutions"
            :key="index"
            :prop-button-label="item.panel_label !==''? item.panel_label : item.slide_title"
            :class="[{ 'is-current': index === current.number ? true : false }, 'btn-' + index]"
            @buttonClick="clickHandle(index)"
          >
            {{ index + 1 }}
          </Button>
        </div>
        <div class="vgsi__panel-buttons__bottom">
          <!-- hotline-->
          <Button
            v-if="hotline"
            :prop-button-label="hotline.text"
            class="is-hotline has-svg-icon"
            @click.native="clickContactHandle()"
          >
            <svg
              enable-background="new 0 0 480.56 480.56"
              version="1.1"
              viewBox="0 0 480.56 480.56"
              xml:space="preserve"
              xmlns="http://www.w3.org/2000/svg">
              <path d="m365.35 317.9c-15.7-15.5-35.3-15.5-50.9 0-11.9 11.8-23.8 23.6-35.5 35.6-3.2 3.3-5.9 4-9.8 1.8-7.7-4.2-15.9-7.6-23.3-12.2-34.5-21.7-63.4-49.6-89-81-12.7-15.6-24-32.3-31.9-51.1-1.6-3.8-1.3-6.3 1.8-9.4 11.9-11.5 23.5-23.3 35.2-35.1 16.3-16.4 16.3-35.6-0.1-52.1-9.3-9.4-18.6-18.6-27.9-28-9.6-9.6-19.1-19.3-28.8-28.8-15.7-15.3-35.3-15.3-50.9 0.1-12 11.8-23.5 23.9-35.7 35.5-11.3 10.7-17 23.8-18.2 39.1-1.9 24.9 4.2 48.4 12.8 71.3 17.6 47.4 44.4 89.5 76.9 128.1 43.9 52.2 96.3 93.5 157.6 123.3 27.6 13.4 56.2 23.7 87.3 25.4 21.4 1.2 40-4.2 54.9-20.9 10.2-11.4 21.7-21.8 32.5-32.7 16-16.2 16.1-35.8 0.2-51.8-19-19.1-38.1-38.1-57.2-57.1z"/>
              <path d="m346.25 238.2 36.9-6.3c-5.8-33.9-21.8-64.6-46.1-89-25.7-25.7-58.2-41.9-94-46.9l-5.2 37.1c27.7 3.9 52.9 16.4 72.8 36.3 18.8 18.8 31.1 42.6 35.6 68.8z"/>
              <path d="m403.95 77.8c-42.6-42.6-96.5-69.5-156-77.8l-5.2 37.1c51.4 7.2 98 30.5 134.8 67.2 34.9 34.9 57.8 79 66.1 127.5l36.9-6.3c-9.7-56.2-36.2-107.2-76.6-147.7z"/>
            </svg>
          </Button>
          <!-- hotline-->
          <Button
            v-if="more"
            :prop-button-label="more.text"
            class="is-more has-svg-icon"
          >
            <svg
              viewBox="0 0 23 14"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                transform="translate(0 14) rotate(-90)"
                d="M7,0l7,9H0Z"
                fill="#333"
              />
              <path
                transform="translate(23) rotate(90)"
                d="M7,0l7,9H0Z"
                fill="#333"
              />
            </svg>
          </Button>
        </div>
        <!-- all solution -->
      </div>
    </div>
  </div>
</template>

<script>
import Button from './Button'
export default {
  name: 'Panel',
  components: {
    Button
  },
  props: {
    solutions: {
      type: Array,
      default: () => [],
      required: true
    },
    hotline: {
      type: Object,
      default: () => ({})
    },
    more: {
      type: Object,
      default: () => ({})
    },
    currentFloor: {
      type: Number,
      default: 0,
      required: true
    }
  },
  data () {
    return {
      current: {
        number: 0,
        label: ''
      }
    }
  },
  watch: {
    currentFloor (newValue) {
      this.updateData(newValue)
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    clickHandle (idx) {
      this.$geb.emit({ id: 'levelPress', payload: idx })
    },
    clickContactHandle () {
      let contactBtn = document.getElementById('inquiries-btn')
      if (contactBtn) {
        contactBtn.click()
      }
    },
    updateData (newValue) {
      const floorData = this.solutions[this.currentFloor]
      this.current.label = (floorData.panel_label !== '') ? floorData.panel_label : floorData.slide_title
      this.current.number = newValue
    },
    initData () {
      if (this.solutions) {
        const val = this.solutions[0]
        this.current.label = val.slide_title
        this.current.number = 0
      }
    }
  }
}
</script>

<style lang="scss">
$text-color: #374348;
$blue-color: #006893;
$red-color: #FF0800;
$arrow-size: 8px;
.vgsi{
  &__panel {
    background: rgb(203,203,203);
    background: linear-gradient(90deg, rgba(203,203,203,1) 0%, rgba(230,230,230,1) 100%);
    height: 100%;
    min-height: 100vh;
    position: absolute;
    top: 0;
    left: 15px;
    z-index: 10;
    padding: 0;
    min-width: 260px;
    width: 20.792vw;
    display: flex;
    flex-direction: column;
    color: #fff;
    &-top{
      background: #000000;
      color: $blue-color;
      padding: 9.85% 1.5rem;
      display: flex;
      align-items: center;
    }
    &-indicator {
      font-size: 3.125vw;
      font-weight: bold;
      line-height: 1.3;
      min-width: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      &-label h4{
        line-height: 1.1;
        text-transform: uppercase;
      }
    }
    &-current { padding-right: 0.5rem; }
    &-direction {
      display: flex;
      flex-direction: column;
      align-items: center;
      .arrow-up { margin-top: 4px; margin-bottom: 4px}
    }
    &-body {
      padding: 1rem
    }
    &-buttons {
      padding-top: 1rem;
      &__top{
        display: flex;
        flex-wrap: wrap-reverse;
        justify-content: center;
      }
      &__bottom{
        display: flex;
        justify-content: center;
      }
    }
  }
}
.arrow-up {
  width: 0;
  height: 0;
  border-left: $arrow-size solid transparent;
  border-right: $arrow-size solid transparent;
  border-bottom: $arrow-size solid $blue-color;
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: $arrow-size solid transparent;
  border-right: $arrow-size solid transparent;
  border-top: $arrow-size solid $blue-color;
}

/* Metal ------------------------- */

.metal {
  outline: none;
  background-color: hsl(0,0%,90%);
  box-shadow: inset hsla(0,0%,15%,  1) 0  0px 0px 4px, /* border */
    inset hsla(0,0%,15%, .8) 0 -1px 5px 4px, /* soft SD */
    inset hsla(0,0%,0%, .25) 0 -1px 0px 7px, /* bottom SD */
    inset hsla(0,0%,100%,.7) 0  2px 1px 7px, /* top HL */
    hsla(0,0%, 0%,.15) 0 -5px 6px 4px, /* outer SD */
    hsla(0,0%,100%,.5) 0  5px 6px 4px; /* outer HL */
  transition: color .2s;
  &.linear {
    background-image: -webkit-repeating-linear-gradient(left, hsla(0,0%,100%,0) 0%, hsla(0,0%,100%,0)   6%, hsla(0,0%,100%, .1) 7.5%),
      -webkit-repeating-linear-gradient(left, hsla(0,0%,  0%,0) 0%, hsla(0,0%,  0%,0)   4%, hsla(0,0%,  0%,.03) 4.5%),
      -webkit-repeating-linear-gradient(left, hsla(0,0%,100%,0) 0%, hsla(0,0%,100%,0) 1.2%, hsla(0,0%,100%,.15) 2.2%),
      linear-gradient(180deg, hsl(0,0%,78%)  0%,
      hsl(0,0%,90%) 47%,
      hsl(0,0%,78%) 53%,
      hsl(0,0%,70%)100%);
  }

}
@media screen and (min-width: 1366px) {
  .vgsi__panel {
    &-indicator {
      min-width: 80px;
    }
    &-indicator-label {
      padding-left: 1rem;
      padding-right: 7rem;
    }
  }
}
</style>
